import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { track } from '../../helpers';
import Question from '../question';

const findTagName = (tags, id) => {
  return tags.find(tag => tag.id === id).name;
};

class QuestionPage extends Component {
  constructor(props) {
    super(props);
    this.onAnswer = this.onAnswer.bind(this);
  }

  onAnswer(answer) {
    const { history, tags, allTags } = this.props;
    const { id, toQuestion } = answer;

    let path = tags.length > 0 ? `/${tags.join('/')}` : '';
    path += `/${id}`;

    track('Answer', findTagName(allTags, id));

    if (toQuestion) {
      history.push(`/questions${path}`);
    }
    else {
      history.push(`/results${path}`);
    }
  }

  renderBackLink(tags) {
    if (tags.length > 0) {
      const prevQuestionPath = `/questions/${tags.slice(0, tags.length - 2).join('/')}`;
      return (
        <Link to={prevQuestionPath} className="f6 mb4-ns mb2 dib light-blue-gray o-40 link v-middle">
          <img src="/back-icon.svg" alt="Back arrow" width={6} className="dib mr2"/>
          Back
        </Link>
      );
    }
    return (
      <Link to="/" className="f6 mb4-ns mb2 dib light-blue-gray o-40 link v-middle">
        <img src="/back-icon.svg" alt="Back arrow" width={6} className="dib mr2"/>
        Back
      </Link>
    );
  }

  render() {
    const styleInner = {
      margin: "auto",
    };

    const { question, tags } = this.props;

    if (!question) {
      return null;
    }

    return (
      <div className="w-90-l w-100 tc pa3" style={styleInner} >
        {this.renderBackLink(tags)}
        <Question question={question} onAnswer={this.onAnswer} />
      </div>
    );
  }
}

QuestionPage.propTypes = {
  history: PropTypes.object,
  question: PropTypes.object,
  tags: PropTypes.array,
  allTags: PropTypes.array,
};

export default QuestionPage;



// WEBPACK FOOTER //
// ./src/components/question-page/QuestionPage.js